import React from "react";
import "./styles/records.css";
import { createBrowserRouter, createRoutesFromElements, RouterProvider, Outlet, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { RefDataProvider } from "./context/RefDataContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ApplicationError from "./components/ApplicationError";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import { RequestPasswordReset, ResetPassword } from "./pages/PasswordRecovery";
import Dashboard from "./pages/Dashboard";
import Vehicles from "./pages/Vehicles";
import VehicleDetail from "./pages/VehicleDetail";
import Reports from "./pages/Reports";
import CalendarPage from "./pages/CalendarPage";
import Handovers from "./pages/Handovers";
import Settings from "./pages/Settings";
import Economics from "./pages/Economics";
import Tariffs from "./pages/Tariffs";
import Rentals from "./pages/Rentals";
import ClientDetail from "./pages/ClientDetail";
import Clienti from "./pages/Clienti";
import Activity from "./pages/Activity";
import {
  AssignmentsPage, MaintenancesPage, DeadlinesPage, CostsPage, RefuelingsPage,
  DamagesPage, FinesPage, SuppliersPage, UsersPage, SitesPage,
} from "./pages/ResourcePages";

const P = ({ children }) => (
  <ProtectedRoute>
    <RefDataProvider>
      <Layout>{children}</Layout>
    </RefDataProvider>
  </ProtectedRoute>
);

const router = createBrowserRouter(createRoutesFromElements(
  <Route errorElement={<ApplicationError />} element={<AuthProvider><Outlet /><Toaster position="top-right" richColors /></AuthProvider>}>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<RequestPasswordReset />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<P><Dashboard /></P>} />
          <Route path="/veicoli" element={<P><Vehicles /></P>} />
          <Route path="/veicoli/:id" element={<P><VehicleDetail /></P>} />
          <Route path="/assegnazioni" element={<P><AssignmentsPage /></P>} />
          <Route path="/consegne" element={<P><Handovers /></P>} />
          <Route path="/manutenzioni" element={<P><MaintenancesPage /></P>} />
          <Route path="/scadenze" element={<P><DeadlinesPage /></P>} />
          <Route path="/costi" element={<P><CostsPage /></P>} />
          <Route path="/rifornimenti" element={<P><RefuelingsPage /></P>} />
          <Route path="/danni" element={<P><DamagesPage /></P>} />
          <Route path="/multe" element={<P><FinesPage /></P>} />
          <Route path="/calendario" element={<P><CalendarPage /></P>} />
          <Route path="/report" element={<P><Reports /></P>} />
          <Route path="/economia" element={<P><Economics /></P>} />
          <Route path="/tariffe" element={<P><Tariffs /></P>} />
          <Route path="/noleggi" element={<P><Rentals /></P>} />
          <Route path="/noleggi/:id" element={<P><Rentals /></P>} />
          <Route path="/clienti" element={<P><Clienti /></P>} />
          <Route path="/clienti/:id" element={<P><ClientDetail /></P>} />
          <Route path="/sedi" element={<P><SitesPage /></P>} />
          <Route path="/utenti" element={<P><UsersPage /></P>} />
          <Route path="/fornitori" element={<P><SuppliersPage /></P>} />
          <Route path="/impostazioni" element={<P><Settings /></P>} />
          <Route path="/attivita" element={<P><Activity /></P>} />
  </Route>
));

function App() {
  return <RouterProvider router={router} />;
}

export default App;
